import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CartPageState from "@TKCCP/Store/Pages/Cart/TkccpCartState";
import { Draft } from "immer";

const initialState: CartPageState = {
    isUpdatingCart: false,
};

const reducer = {
    "Pages/TkccpCart/BeginUpdateCart": (draft: Draft<CartPageState>) => {
        draft.isUpdatingCart = true;
    },
    "Pages/TkccpCart/CompleteUpdateCart": (draft: Draft<CartPageState>) => {
        draft.isUpdatingCart = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
